module.exports = __webpack_public_path__ + "img/reference-skulpturen-mittendorfer.b0620881.jpg";